import { useState } from 'react';
import { Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function InputModal({ show, onHide, title, content, inputLabel, onAcceptClick, onCancelClick }) {
    const [value, setValue] = useState('');

    const handleInputChange = (e) => {
        setValue(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onAcceptClick(value);
        setValue('');
    }

    const handleAcceptButtonClick = () => {
        onAcceptClick(value);
        setValue('');
    };

    const handleCancelButtonClick = () => {
        setValue('');
        onCancelClick();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {content}
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="fileName">
                        <Form.Label>{inputLabel ?? 'Name'}</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={value} 
                            onChange={handleInputChange} 
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <div className='w-100 d-flex justify-content-between'>
                    <Button variant='outline-dark' onClick={handleCancelButtonClick}>{'Cancel'}</Button>
                    <Button variant='primary' onClick={handleAcceptButtonClick}>{'Confirm'}</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default InputModal;